require("./solutions.scss");
import {submitMailCta} from "../utils";

const sliderAction = () => {
    const scrollOffset = $(window).width() < 768 ? -200 : 0;

    $('.slide-arrow').on('click.sliderAction', function () {
        if ($(window).width() < 768) {
            const targetPosition = $('.navigation-slider').get(0).getBoundingClientRect().top + window.scrollY;
            window.scrollTo({top: targetPosition + scrollOffset, behavior: 'smooth'});
        }
    });
};

const changePage = (page) => {
    $('.right_menu, .content-page:not(.static)').addClass('d-none');
    $(`#right_menu_${page}, #page_${page}`).removeClass('d-none');
    $('.side_menu_item').removeClass('active');
    $(`#side_menu_${page}`).addClass('active');

    const isFirstPage = page === 1;
    const isLastPage = $('.content-page:not(.static)').length === page;

    $("#current-page").val(page - 1);
    $("#counter_page").html(page);
    $("#previous_page").prop("disabled", isFirstPage);
    $("#next_page").prop("disabled", isLastPage);
};

const slidePage = (direction) => {
    const currentPage = parseInt($("#current-page").val());
    const newPage = currentPage + direction;

    changePage(newPage + 1);
};

$(() => {

    sliderAction();
    $(window).on('resize', sliderAction);

    $('.side_menu_item').on('click', function () {
        changePage($(this).data('page'));
    });

    $('.slide-arrow').on('click', function () {
        slidePage($(this).data('direction'));
    });

    submitMailCta();
});
